import styled from 'styled-components';

export const Container = styled.div`
  @media only screen and (max-width: 768px) {
    .col-md-7 {
      padding: 0px;
      margin-top: 20px;
    }
  }

  .equal-height {
    display: flex;
    flex-wrap: wrap;
    gap: 15px;
  }

  .equal-height > div {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-height: 150px;
  }
`;

export const Cards = styled.div`
  .card-container {
    margin-bottom: 30px;

    &:last-child {
      margin-bottom: 0;
    }
  }
`;
